import { ToolResultState } from "@/components/ToolsResultPage/redux/types";

const toolResultInitialState: ToolResultState = {
  type: "",
  content: null,
  toolData: null,
  seo: null,
};

export default toolResultInitialState;
